import OrderEditViewStore from '@components/order/stores/OrderEditViewStore';
import { Box } from '@mui/system';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React from 'react';
import OrderCartEmpty from '../OrderCartEmpty';
import OrderCartFoodListItem from './OrderCartFoodListItem';

interface OrderFoodListProps {
    orderEditViewStore: OrderEditViewStore;
}

const OrderFoodList: React.FC<OrderFoodListProps> = observer(({ orderEditViewStore }) => {
    const { orderFoods, onOrderFoodEditClick, onOrderFoodRemoveClick } = orderEditViewStore;

    if (orderFoods.length === 0) {
        return <OrderCartEmpty />
    }

    return (
        <Box display={"flex"} flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
            {_.map(orderFoods, (orderFood, index) => (
                <OrderCartFoodListItem key={`${orderFood.foodId}-${index}`} orderFood={orderFood} onEditClick={onOrderFoodEditClick} onRemoveClick={onOrderFoodRemoveClick} />
            ))}
        </Box>
    )
})

export default OrderFoodList;